/**
 * Free providers get the person's name instead of the domain: a workspace called "Gmail"
 * is worse than one called "Ana's workspace". Phase 2's Google signup calls this too, which
 * is why it lives in shared rather than in the signup screen.
 */
const FREE_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'yahoo.com',
  'proton.me',
  'protonmail.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'gmx.com',
  'yandex.com',
  'fastmail.com',
  'zoho.com',
])

export function deriveOrgName(email: string, personName: string): string {
  const person = personName.trim()
  const fallback = person === '' ? 'My workspace' : `${person}'s workspace`

  const at = email.trim().lastIndexOf('@')
  if (at === -1) return fallback

  const domain = email.trim().slice(at + 1).toLowerCase()
  if (domain === '' || !domain.includes('.')) return fallback
  if (FREE_EMAIL_DOMAINS.has(domain)) return fallback

  const label = domain.split('.')[0] ?? ''
  if (label === '') return fallback

  return label
    .split('-')
    .filter((part) => part !== '')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}
